// ISO week helpers — Monday = day 1, Sunday = day 7.
// Week key format: "YYYY-Www" e.g. "2026-W06".

export function getISOWeekKey(date = new Date()) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7; // Sunday -> 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum); // shift to Thursday of the week
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, "0")}`;
}

export function isSunday(date = new Date()) {
  return date.getDay() === 0;
}

export function weekKeyToLabel(weekKey) {
  // Parse "2026-W06" -> "Week 6 · 2026"
  const m = /^(\d{4})-W(\d{2})$/.exec(weekKey || "");
  if (!m) return weekKey;
  return `Week ${parseInt(m[2], 10)} · ${m[1]}`;
}

export function weekKeyToDateRange(weekKey) {
  // Returns "Mon DD – Sun DD, YYYY" for the ISO week (Mon..Sun).
  const m = /^(\d{4})-W(\d{2})$/.exec(weekKey || "");
  if (!m) return "";
  const year = parseInt(m[1], 10);
  const week = parseInt(m[2], 10);
  // ISO week 1: week containing Jan 4. Find Monday of that week.
  const jan4 = new Date(Date.UTC(year, 0, 4));
  const jan4Day = jan4.getUTCDay() || 7;
  const week1Monday = new Date(jan4);
  week1Monday.setUTCDate(jan4.getUTCDate() - (jan4Day - 1));
  const monday = new Date(week1Monday);
  monday.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7);
  const sunday = new Date(monday);
  sunday.setUTCDate(monday.getUTCDate() + 6);
  const fmt = (dt) =>
    dt.toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });
  return `${fmt(monday)} – ${fmt(sunday)}, ${sunday.getUTCFullYear()}`;
}
